<template>
  <div class="box-curriculo text-center" >
    <model-display-component :position.sync="currentPositionTab" :avaiablePositions.sync="avaiablePositions"></model-display-component>
    <hr class="m-0" >
    <div class="card-body card-initial">
      <div class="selecione-tipo pb-4" :class="{'pb-5': currentPositionTab == 1, 'selecione-dados': currentPositionTab > 1}" >
        <h5 class="tituloH5 color-secondary mb-72" >{{currentPositionTab}}. {{currentTitle}}</h5>
          <select-model-component v-show="currentPositionTab == 1" key="1" :avaiableModels="avaiableModels" :currentPosition.sync="dataValues.currentPositionSelectModel"></select-model-component>
          <data-input-component
            v-model="dataValues.resultData"
            v-show="currentPositionTab == 2"
            key="2"
            :valid.sync="validationMap.validDataInput"
          ></data-input-component>
          <formation-input-component
            v-model="dataValues.resultFormation"
            v-show="currentPositionTab == 3"
            key="3"
            v-on:formHasChange="onFormHasChange($event)"
            :avaiableCourses="avaiableCourses"
          ></formation-input-component>
          <experience-input-component
            v-model="dataValues.resultExperience"
            v-show="currentPositionTab == 4"
            v-on:formHasChange="onFormHasChange($event)"
            key="4"></experience-input-component>
          <language-input-component v-model="dataValues.resultLanguage" v-show="currentPositionTab == 5" key="5"></language-input-component>
          <skills-input-component v-model="dataValues.resultSkills" v-show="currentPositionTab == 6" key="6"></skills-input-component>
          <download-input-component v-model="dataValues.resultDownload" v-show="currentPositionTab == 7" @download="downloadAction" key="7"></download-input-component>
        <a href="javascript:void(0);" class="botao botao-pequeno botao-icone-azul float-left mt-4 curriculo-voltar" v-show="currentPositionTab > 1 && currentPositionTab < 8"  @click="backSelection()"><span class="d-none d-md-block" >Voltar</span></a>
        <a href="javascript:void(0);" class="botao botao-success botao-pequeno botao-icone mt-4 curriculo-continuar mr-sm-0 float-right" @click="nextSelection(currentPositionTab+1)" v-show="currentPositionTab < 7"><span class="d-none d-md-block" >Continuar</span></a>
      </div>
    </div>
    
  </div>
</template>

<script>
import DataInputComponent from './components/DataInputComponent.vue'
import ExperienceInputComponent from './components/ExperienceInputComponent.vue'
import FormationInputComponent from './components/FormationInputComponent.vue'
import LanguageInputComponent from './components/LanguageInputComponent.vue'
import ModelDisplayComponent from './components/ModelDisplayComponent.vue'
import SelectModelComponent from './components/SelectModelComponent.vue'
import SkillsInputComponent from './components/SkillsInputComponent.vue'
import DownloadInputComponent from './components/DownloadInputComponent.vue'
import ResumeAPI from './api/resume'


export default {
  name: 'App',
  components: {
    ModelDisplayComponent,
    SelectModelComponent,
    DataInputComponent,
    FormationInputComponent,
    LanguageInputComponent,
    ExperienceInputComponent,
    SkillsInputComponent,
    DownloadInputComponent
  },
  data() {
    return {
      validationMap: {
        validDataInput: false,
      },
      currentPositionTab: 1,
      avaiablePositions: [
        {
          position: 1,
          text: 'Modelo',
          title: 'Escolha um modelo'
        },
        {
          position: 2,
          text: 'Dados',
          title: 'Dados'
        },
        {
          position: 3,
          text: 'Formação',
          title: 'Formação Acadêmica e Certificações',
          hasModification: false
        },
        {
          position: 4,
          text: 'Experiência Profissional',
          title: 'Experiência profissional',
          hasModification: false
        },
        {
          position: 5,
          text: 'Idioma',
          title: 'Idiomas'
        },
        {
          position: 6,
          text: 'Habilidades',
          title: 'Habilidades'
        },
        {
          position: 7,
          text: 'Download',
          title: 'Download'
        },
      ],
      avaiableModels: [
        {
          'id': 1,
          'name': 'Modelo clássico'
        },
        {
          'id': 2,
          'name': 'Modelo moderno'
        },
        {
          'id': 3,
          'name': 'Modelo normal'
        },
      ],
      avaiableCourses: [],
      dataValues: {
        currentPositionSelectModel: 1,
        currentSelectModel: null,
        resultData: {
          name: '',
          file: null,
          email: '',
          cellphone: '',
          description: '',
          titleProfission: '',
          city: null,
          state: null,
          urlPreview: null
        },
        resultFormation: [],
        resultExperience: [],
        resultLanguage: [
        ],
        resultSkills: {
          skillsValue: [],
        },
        resultDownload: {
         optionDownload: null,
        }
      }
    }
  },
  mounted() {
    let curriculoData = localStorage.getItem("curriculo-datacomp");
    if (curriculoData){
      let compData = JSON.parse(curriculoData);
      const OneDay = new Date().getTime() + (1 * 24 * 60 * 60 * 1000)
      if (OneDay > new Date(compData.time)) {
        this.dataValues = compData.data;
        this.currentPositionTab = compData.position;
      } else { 
        localStorage.removeItem("curriculo-datacomp");
      }
    }
    this.loadCourses();
  },
  watch: {
    dataValues: {
      handler(val) {
        let item =  this.avaiableModels[val.currentPositionSelectModel - 1];
        this.dataValues.currentSelectModel = item;
        this.setLocalStorage();
      },
      deep: true
    },
    currentPositionTab: {
      handler() {
        this.setLocalStorage();
      }
    }
  },
  computed: {
    currentTitle() {
      if (this.currentPositionTab <= this.avaiablePositions.length) {
        return this.avaiablePositions[this.currentPositionTab - 1].title;
      }
      return '' 
    }
  },
  methods: {
    downloadFile(response) {
      const blob = new Blob([response.data], {type: response.data.type});
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      console.log(this.dataValues.resultDownload.optionDownload.id)
      let fileName = "unknow"
      if(this.dataValues.resultDownload.optionDownload.id == 2) {
          fileName = 'curriculo.docx';
      }else{
          fileName = 'curriculo.pdf';
      }
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    setLocalStorage(){
      let dataComp = {
        data: this.dataValues,
        position: this.currentPositionTab,
        time: new Date()
      }
      localStorage.setItem('curriculo-datacomp', JSON.stringify(dataComp))
    },
    nextSelection(value) {
      if (this.currentPositionTab == 2 && !this.validationMap.validDataInput){
        this.$swal({
          icon: 'warning',
          title: 'Você esqueceu de algo?',
          text: 'Verifique se as informações digitadas estão corretamente preenchidas para prosseguir',
        })
        return;
      }
      
      if ((this.currentPositionTab === 3 || this.currentPositionTab === 4) && this.avaiablePositions[this.currentPositionTab-1].hasModification) {
        this.$swal({
          icon: 'warning',
          title: 'Tem certeza de que quer continuar',
          html: 'Parece que as informações que você preencheu <b>não foran salvas</b>. Se você continuar, elas serão perdidas.',
          confirmButtonText: 'Voltar para página' 
        })
        return
      }
      this.currentPositionTab = value;
    },
    onFormHasChange: function(ev) {
      this.avaiablePositions[this.currentPositionTab -1].hasModification = ev;
    },
    backSelection() {
      this.currentPositionTab = this.currentPositionTab - 1;
    },
    downloadAction() {
      if(!this.dataValues.resultDownload.optionDownload){
        return;
      }
      let self = this;
      if(this.dataValues.resultDownload.optionDownload.id == 1) {
        ResumeAPI.sendResumePDF(self.dataValues).then(function(response) {
          self.downloadFile(response);
          localStorage.removeItem("curriculo-datacomp");
        })
        .catch(function(error) {
          alert(error);
        });
      } else if (this.dataValues.resultDownload.optionDownload.id == 2) {
        ResumeAPI.sendResumeDOC(self.dataValues).then(function(response) {
          self.downloadFile(response);
          localStorage.removeItem("curriculo-datacomp");
        })
        .catch(function(error) {
          alert(error);
        });
      }
    },
    loadCourses() {
      let self = this;
      ResumeAPI.getCourses().then(function(response) {
        self.avaiableCourses = response.data;
      })
      .catch(function(error) {
        alert(error);
      });
  },
  }
}
</script>

<style>

</style>
